import utils from './utils'
const { add, subtract } = utils

const TABLE_BUDGET_BASE = {
  budgetId: undefined,
  name: '',
  budgetPid: undefined,
  projectId: undefined,
  year: undefined,
  price: undefined,
  quantity: undefined,
  amount: undefined,
  // 甘特图任务类型
  type: 'task',
  remark: '',
  editing: false,
  // 表格rowKey及甘特图任务id
  uid: undefined,
  puid: undefined,
  // 甘特图上级任务id
  parentId: undefined,
  collapsed: false,
  showYearPanel: false,
  applied: undefined,
  expensed: undefined,
  allocated: undefined,
  cateRoot: undefined,
  cateId: undefined,
  cateName: '',
  cateFullName: '',
  costRate: undefined,
}

const createBudgetTree = (records, parent, extProps = {}) => {
  let data = records
    .filter(d => d.budgetPid === (parent ? parent.budgetId : 0))
    .map((record, index) => {
      let { budgetId, budgetPid, projectId, name, pname, year, price, quantity, amount, remark, applied, applyAmount, expensed, allocated, invoices, cateRoot, cateName, cateId, costRate } = record
      let item = {
        ...TABLE_BUDGET_BASE,
        no: parent ? `${parent.no}-${index + 1}` : `${index + 1}`,
        uid: budgetId,
        puid: budgetPid,
        budgetId,
        budgetPid,
        name,
        pname,
        year: year ? `${year}` : undefined,
        price,
        quantity,
        amount,
        projectId,
        remark,
        applied,
        applyAmount,
        remainApplied: applied ? applied - (expensed || 0) : 0,
        accuRemainApplied: applied ? applied - (expensed || 0) : 0,
        expensed,
        allocated,
        isRoot: parent ? 0 : 1,
        invoices,
        cateRoot,
        cateId,
        cateName,
        costRate,
        cateFullName: [1, 2, 3].includes(cateRoot) ? `${cateRoot == 1 ? '项目费' : cateRoot == 2 ? '申请人管理费' : '美丽心灵管理费'}（${cateName}）` : '',
        ...extProps,
      }
      item.children = createBudgetTree(records, item, extProps)
      return item
    })
  return parent ? (data.length ? data : undefined) : data
}

const TABLE_TASK_BASE = {
  taskId: undefined,
  taskName: '',
  taskPid: undefined,
  taskType: undefined,
  ownerType: 1,
  owner: undefined,
  ownerId: undefined,
  projectId: undefined,
  remark: '',
  startDate: undefined,
  endDate: undefined,
  period: undefined,
  editing: false,
  // 表格rowKey及甘特图任务id
  uid: undefined,
  puid: undefined,
  // 甘特图任务类型
  type: 'task',
  // 甘特图上级任务id
  parentId: undefined,
  collapsed: false,
  dates: [],
  budgets: [],
  budgetIds: [],
}

const createTaskTree = (records, parent, extProps = {}) => {
  let data = records
    .filter(d => d.taskPid === (parent ? parent.taskId : 0))
    .map((record, index) => {
      let {
        taskId,
        taskPid,
        projectId,
        stagePlanId,
        taskName,
        taskType,
        taskState,
        remark,
        startDate,
        endDate,
        files = [],
        restDays,
        actualStartDate,
        actualEndDate,
        checkState,
        checkOpinion,
        checkResult,
        outcomeType,
        ownerType,
        owner,
        ownerId,
        submitTime,
        period,
        isExpired,
        budgets,
        creator,
      } = record
      let item = {
        ...TABLE_TASK_BASE,
        no: parent ? `${parent.no}-${index + 1}` : `${index + 1}`,
        uid: taskId,
        puid: taskPid,
        taskId,
        taskPid,
        taskName,
        taskState,
        taskType,
        remark,
        projectId,
        stagePlanId,
        startDate,
        endDate,
        dates: startDate && endDate ? [startDate, endDate] : [],
        files,
        restDays,
        actualStartDate,
        actualEndDate,
        isExpired,
        submitTime,
        checkState,
        checkOpinion,
        checkResult,
        outcomeType,
        ownerType,
        owner,
        ownerId: ownerId ? `${ownerId}` : undefined,
        period,
        creator,
        budgets,
        budgetIds: budgets ? budgets.map(d => d.budgetId) : [],
        isRoot: parent ? 0 : 1,
        ...extProps,
      }
      item.children = createTaskTree(records, item, extProps)
      return item
    })
  return parent ? (data.length ? data : undefined) : data
}

export const createNewBudget = () => ({ ...TABLE_BUDGET_BASE })

export const createNewTask = () => ({ ...TABLE_TASK_BASE, uuid: Math.random() })

export const convertTasksToTableData = (records, extProps = {}) => createTaskTree(records, null, extProps)

export const convertBudgetsToTableData = (records, extProps) => createBudgetTree(records, null, extProps)

/**
 * 将预算变更表转换为变更信息
 * @param {*} records
 * @param {*} extProps
 * @returns
 */
export const convertTableToChangedBudgets = (records, extProps = []) => {
  return records.map(item => {
    let { budgetId, name, amount, children } = item
    let budget = {
      budgetId,
      name,
      amount,
    }
    extProps.forEach(prop => {
      budget[prop] = item[prop]
    })
    if (children && children.length) {
      budget.children = children.map(item => ({
        budgetId: item.budgetId,
        budgetPid: budgetId,
        name: item.name,
        year: item.year,
        quantity: item.quantity,
        price: item.price,
        amount: item.amount,
        remark: item.remark,
        cateId: item.cateId,
        cateRoot: item.cateRoot,
        cateName: item.cateName,
        ...extProps.map(prop => ({ [prop]: item[prop] })).reduce((prev, a) => ({ ...prev, ...a }), {}),
      }))
    }
    return budget
  })
}

/**
 * 将计划变更表转换为变更信息
 * @param {*} records
 * @param {*} extProps
 * @returns
 */
export const convertTableToChangedTasks = (records, extProps = []) => {
  return records.map(item => {
    let { taskId, taskName, children } = item
    let record = {
      taskId,
      taskName,
    }
    extProps.forEach(prop => {
      record[prop] = item[prop]
    })
    if (children && children.length) {
      record.children = children.map(item => ({
        taskId: item.taskId,
        taskPid: taskId,
        taskName: item.taskName,
        taskType: item.taskType,
        startDate: item.startDate,
        ownerType: item.ownerType,
        owner: item.owner,
        ownerId: item.ownerId,
        endDate: item.endDate,
        period: item.period,
        amount: item.amount,
        remark: item.remark,
        budgets: item.budgets.map(({ budgetId, budgetPid, name, pname, amount }) => ({ budgetId, budgetPid, name, pname, amount })),
        ...extProps.map(prop => ({ [prop]: item[prop] })).reduce((prev, a) => ({ ...prev, ...a }), {}),
      }))
    }
    return record
  })
}

/**
 * 将计划变更信息转换为表数据
 * @param {*} records
 * @returns
 */
export const convertChangedTasksToTable = records => {
  return records.map(item => {
    let { taskId, taskName, changeType, children } = item
    let uid = taskId || Math.random()
    let record = {
      ...TABLE_TASK_BASE,
      uid,
      taskId,
      taskName,
      changeType,
      isRoot: 1,
      // 新增或变更，编辑状态
      editing: changeType === 0 || changeType === 2,
    }
    if (children && children.length) {
      record.children = children.map(item => ({
        ...TABLE_TASK_BASE,
        taskId: item.taskId,
        taskPid: taskId,
        uid: item.taskId || Math.random(),
        puid: uid,
        taskName: item.taskName,
        taskType: item.taskType,
        startDate: item.startDate,
        endDate: item.endDate,
        dates: item.startDate ? [item.startDate, item.endDate] : [],
        period: item.period,
        amount: item.amount,
        remark: item.remark,
        budgets: item.budgets,
        budgetIds: item.budgets.map(d => d.budgetId),
        changeType: item.changeType,
        ownerType: item.ownerType,
        owner: item.owner,
        ownerId: item.ownerId,
        isRoot: 0,
        editing: item.changeType === 0 || item.changeType === 2,
      }))
    }
    return record
  })
}

/**
 * 将预算变更信息转换为表数据
 * @param {*} records
 * @param {*} budgets
 * @param {*} param2
 * @returns
 */
export const convertChangedBudgetsToTable = (records, budgets, { showTotal = true, showRaise = true, showRemain = true, showManage = false, showOwnManage = false, manageRate = 0, ownManageRate = 0, raisedAmount }) => {
  let amountTotal = 0
  let appliedTotal = 0
  let expensedTotal = 0
  let tableRecords = records.map(item => {
    let { budgetId, name, amount = 0, changeType, children } = item
    let uid = budgetId || Math.random()
    let applied = 0
    let expensed = 0
    let record = {
      ...TABLE_BUDGET_BASE,
      uid,
      budgetId,
      name,
      amount,
      changeType,
      isRoot: 1,
      // 新增或变更，编辑状态
      editing: changeType === 0 || changeType === 2,
    }
    if (children && children.length) {
      record.children = children.map(item => {
        let child = {
          ...TABLE_BUDGET_BASE,
          budgetId: item.budgetId,
          budgetPid: budgetId,
          uid: item.budgetId || Math.random(),
          puid: uid,
          name: item.name,
          quantity: item.quantity,
          price: item.price,
          year: item.year ? `${item.year}` : undefined,
          amount: item.amount,
          remark: item.remark,
          changeType: item.changeType,
          isRoot: 0,
          applied: 0,
          expensed: 0,
          remainApplied: 0,
          cateId: item.cateId,
          cateRoot: item.cateRoot,
          cateName: item.cateName,
          cateFullName: [1, 2, 3].includes(item.cateRoot) ? `${item.cateRoot == 1 ? '项目费' : item.cateRoot == 2 ? '申请人管理费' : '美丽心灵管理费'}（${item.cateName}）` : '',
          editing: item.changeType === 0 || item.changeType === 2,
        }
        if (item.budgetId) {
          let budget = budgets.find(d => d.budgetId == item.budgetId)
          if (budget) {
            child.applied = budget.applied
            child.expensed = budget.expensed
            child.remainApplied = subtract(budget.applied, budget.expensed)
            applied = add(budget.applied || 0, applied)
            expensed = add(budget.expensed || 0, expensed)
          }
        }
        return child
      })
    }
    record.applied = applied
    record.expensed = expensed
    record.remainApplied = subtract(applied, expensed)
    amountTotal = add(amount, amountTotal)
    appliedTotal = add(applied, appliedTotal)
    expensedTotal = add(expensed, expensedTotal)
    return record
  })
  if (tableRecords.length) {
    if (showTotal) {
      let totalRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        name: '合计',
        rowDef: 'total',
        isRoot: 1,
        amount: amountTotal,
        applied: appliedTotal,
        expensed: expensedTotal,
        accuExpensed: expensedTotal,
        remainApplied: subtract(appliedTotal, expensedTotal),
      }
      tableRecords.push(totalRecord)
    }
    if (showRaise) {
      let raiseRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        extra: true,
        rowDef: 'raise',
        name: '筹款金额',
        isRoot: 1,
        amount: raisedAmount,
      }
      tableRecords.push(raiseRecord)
    }
    let manageAmount = manageRate ? (raisedAmount * manageRate) / 100 : 0
    let ownManageAmount = manageRate ? (raisedAmount * ownManageRate) / 100 : 0
    if (showManage) {
      tableRecords.push({
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        rowDef: 'manage',
        extra: true,
        isRoot: 1,
        name: `申请人管理费（费率${manageRate}%）`,
        amount: manageAmount,
      })
    }
    if (showOwnManage) {
      tableRecords.push({
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        rowDef: 'manage',
        extra: true,
        isRoot: 1,
        name: `美丽心灵管理费（费率${ownManageRate}%）`,
        amount: ownManageAmount,
      })
    }
    if (showRemain) {
      tableRecords.push({
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        extra: true,
        rowDef: 'remain',
        remains: true,
        name: '结余',
        isRoot: 1,
        amount: subtract(raisedAmount, manageAmount, ownManageAmount, expensedTotal),
      })
    }
  }
  return tableRecords
}

/**
 * 将预算明细数据转换为表数据
 * @param {*} records
 * @param {*} param1
 * @param {*} extProps
 * @returns
 */
export const convertBudgetsRecords = (records, { showTotal = true, showRaise = true, showRemain = true, showOwnManage = false, showManage = false, manageRate = 0, ownManageRate = 0, raisedAmount = 0 } = {}, extProps = {}) => {
  let tableRecords = convertBudgetsToTableData(records, extProps)
  let amountTotal = 0
  let appliedTotal = 0
  let expensedTotal = 0
  let applyTotal = 0
  let fileTotal = 0
  let yearSet = new Set()
  let rmbRecords = []
  let manageAmount = manageRate ? add((raisedAmount * manageRate) / 100) : 0
  let ownManageAmount = ownManageRate ? add((raisedAmount * ownManageRate) / 100) : 0
  tableRecords.forEach(record => {
    let amount = 0
    let applied = 0
    let apply = 0
    let expensed = 0
    if (record.children) {
      record.children.forEach(item => {
        item.files = item.invoices ? item.invoices.map(d => d.files).flat() : []
        fileTotal += item.files.length
        amount = add(item.amount || 0, amount)
        applied = add(item.applied || 0, applied)
        expensed = add(item.expensed || 0, expensed)
        apply = add(item.applyAmount || 0, apply)
        if (item.year) {
          yearSet.add(item.year)
        }
        item.currentExpensed = 0
        item.accuExpensed = item.expensed || 0
        item.remainApplied = subtract(item.applied, item.expensed)
        item.accuApply = add(item.applied, item.applyAmount || 0)
        item.accuRemainApplied = subtract(item.applied, item.expensed)
        item.remainApply = subtract(item.accuApply, item.expensed)
        item.manageAmount = manageAmount
        item.ownManageAmount = ownManageAmount
        const { cateRoot, cateId, costRate, cateName, cateFullName } = item
        item.cateAmount = undefined
        if (cateId) {
          let cateAmount = undefined
          if (cateRoot == 2) {
            cateAmount = add((manageAmount * (costRate || 0)) / 100)
          }
          if (cateRoot == 3) {
            cateAmount = add((ownManageAmount * (costRate || 0)) / 100)
          }
          item.cateAmount = cateAmount
          let rmbRecord = rmbRecords.find(d => d.cateId == cateId)
          if (!rmbRecord) {
            rmbRecord = {
              uid: Math.random(),
              isRoot: 1,
              cateId,
              cateName,
              cateRoot,
              cateFullName,
              amount: 0,
              costRate,
              manageAmount,
              ownManageAmount,
              cateAmount,
              rmbRate: costRate,
              rmbAmount: undefined,
              applied: 0,
              expensed: 0,
              editing: false,
              children: [],
            }
            rmbRecords.push(rmbRecord)
          }
          rmbRecord.amount = add(item.amount || 0, rmbRecord.amount)
          rmbRecord.applied = add(item.applied || 0, rmbRecord.applied)
          rmbRecord.expensed = add(item.expensed || 0, rmbRecord.expensed)
          rmbRecord.children.push({ ...item })
        }
      })
    }
    record.amount = amount
    record.applied = applied
    record.expensed = expensed
    record.remainApplied = subtract(applied, expensed)
    record.accuRemainApplied = subtract(applied, expensed)
    record.currentExpensed = 0
    record.accuExpensed = expensed
    record.applyAmount = apply
    record.accuApply = add(apply, applied)
    record.remainApply = subtract(record.accuApply, record.expensed)
    amountTotal = add(amount, amountTotal)
    appliedTotal = add(applied, appliedTotal)
    expensedTotal = add(expensed, expensedTotal)
    applyTotal = add(apply, applyTotal)
  })
  rmbRecords.sort((a, b) => a.cateRoot - b.cateRoot)
  // let = [...yearSet]
  if (tableRecords.length) {
    if (showTotal) {
      let remainApplied = subtract(appliedTotal, expensedTotal)
      let totalRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        name: '合计',
        isRoot: 1,
        rowDef: 'total',
        amount: amountTotal,
        applied: appliedTotal,
        expensed: expensedTotal,
        currentExpensed: 0,
        accuExpensed: expensedTotal,
        remainApplied: remainApplied,
        accuRemainApplied: remainApplied,
        applyAmount: applyTotal,
        accuApply: add(applyTotal, appliedTotal),
        remainApply: add(applyTotal, remainApplied),
        fileTotal,
      }
      tableRecords.push(totalRecord)
      rmbRecords.push(totalRecord)
    }
    if (showRaise) {
      let raiseRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        extra: true,
        rowDef: 'raise',
        name: '筹款金额',
        isRoot: 1,
        amount: raisedAmount,
      }
      tableRecords.push(raiseRecord)
      rmbRecords.push(raiseRecord)
    }
    if (showManage) {
      let manageRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        extra: true,
        rowDef: 'manage',
        isRoot: 1,
        name: `申请人管理费（费率${manageRate}%）`,
        amount: manageAmount,
      }
      tableRecords.push(manageRecord)
      rmbRecords.push(manageRecord)
    }
    if (showOwnManage) {
      let ownManageRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        extra: true,
        rowDef: 'manage',
        isRoot: 1,
        name: `美丽心灵管理费（费率${ownManageRate}%）`,
        amount: ownManageAmount,
      }
      tableRecords.push(ownManageRecord)
      rmbRecords.push(ownManageRecord)
    }
    if (showRemain) {
      let remainRecord = {
        uid: Math.random(),
        budgetId: Math.random(),
        sum: true,
        extra: true,
        rowDef: 'remain',
        remains: true,
        name: '结余',
        isRoot: 1,
        amount: subtract(raisedAmount, manageAmount, ownManageAmount, expensedTotal),
      }
      tableRecords.push(remainRecord)
      rmbRecords.push(remainRecord)
    }
  }
  let years = [...yearSet]
  return {
    years,
    tableRecords,
    rmbRecords,
  }
}

export const mergeTableBudgetsAndInvoices = (invoices, tableBudgets) => {
  let budgetMap = {}
  invoices.forEach(invoice => {
    invoice.budgets.forEach(({ budgetId, amount }) => {
      if (amount) {
        if (budgetMap[budgetId] === void 0) {
          budgetMap[budgetId] = 0
        }
        budgetMap[budgetId] += amount
      }
    })
  })
  let currentExpensedTotal = 0
  let accuExpensedTotal = 0
  let accuRemainAppliedTotal = 0
  tableBudgets.forEach(item => {
    if (item.children) {
      let currentExpensed = 0
      let accuExpensed = 0
      let accuRemainApplied = 0
      item.children.forEach(budget => {
        let { applied, expensed, budgetId } = budget
        if (budgetMap[budgetId]) {
          budget.currentExpensed = budgetMap[budgetId]
          budget.accuExpensed = add(expensed, budgetMap[budgetId])
          budget.accuRemainApplied = subtract(applied, budget.accuExpensed)
        } else {
          budget.currentExpensed = 0
          budget.accuExpensed = expensed
          budget.accuRemainApplied = subtract(applied, expensed)
        }
        currentExpensed = add(budget.currentExpensed, currentExpensed)
        accuExpensed = add(budget.accuExpensed, accuExpensed)
        accuRemainApplied = add(budget.accuRemainApplied, accuRemainApplied)
      })
      item.currentExpensed = currentExpensed
      item.accuExpensed = accuExpensed
      item.accuRemainApplied = accuRemainApplied
      currentExpensedTotal = add(currentExpensed, currentExpensedTotal)
      accuExpensedTotal = add(accuExpensed, accuExpensedTotal)
      accuRemainAppliedTotal = add(accuRemainApplied, accuRemainAppliedTotal)
    }
  })
  let sumRecord = tableBudgets.find(d => d.name == '合计')
  sumRecord.currentExpensed = currentExpensedTotal
  sumRecord.accuExpensed = accuExpensedTotal
  sumRecord.accuRemainApplied = accuRemainAppliedTotal
}

export const convertLxForm = formRecord => {
  let { formData, dataDiscription, files, ptype } = formRecord
  let form = JSON.parse(formData)
  let props = JSON.parse(dataDiscription)
  if (ptype == 4) {
    return {
      props,
      data: form,
      files,
    }
  } else {
    Object.keys(form).forEach(key => {
      let labelValue = form[key]
      if (typeof form[key] === 'object') {
        labelValue = Object.values(form[key])
          .map(item => item.name)
          .join('，')
      }
      form[key] = {
        value: labelValue,
        origin_value: form[key],
        is_image: labelValue.startsWith('http') && (labelValue.endsWith('jpg') || labelValue.endsWith('jpeg') || labelValue.endsWith('png') || labelValue.endsWith('gif')),
      }
    })
    return {
      props: props.filter(item => form[item.label_Id] && form[item.label_Id].value),
      data: form,
    }
  }
}
